import { SvgIcon } from '@mui/material';

export function TrustPilotStar(props) {
	return (
		<SvgIcon
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			{...props}
		>
			<path
				d="M6.87321 10L9.99739 9.16666L11.2471 13.125L6.87321 10ZM13.9547 5H8.53944L6.87321 0L5.20697 5H0L4.37386 8.125L2.70763 13.125L7.08148 10L9.78911 8.125L13.9547 5Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
